import {request} from "./request";

export const getAsset = queryParams => {
  return request.get({
    path: "/engine/asset/info",
    queryParams,
  });
};

export const getAssetList = queryParams => {
  return request.get({
    path: "/engine/asset/list",
    queryParams,
  });
};

export const createAsset = params => {
  return request.post({
    path: "/engine/asset/create",
    params,
  });
};

export const updateAsset = (queryParams, params) => {
  return request.put({
    path: "/engine/asset/update",
    queryParams,
    params,
  });
};

export const deleteAsset = queryParams => {
  return request.delete({
    path: "/engine/asset/delete",
    queryParams,
  });
};

export const createAssetLike = params => {
  return request.post({
    path: "/engine/asset/like/create",
    params,
  });
};

export const getAssetLike = queryParams => {
  return request.get({
    path: "/engine/asset/like/list",
    queryParams,
  });
};

export const deleteAssetLike = queryParams => {
  return request.delete({
    path: "/engine/asset/like/delete",
    queryParams,
  });
};

export const uploadAsset = params => {
  return request.post({
    path: "/engine/asset/upload",
    params,
  });
};

export const uploadAssetThumbnail = params => {
  return request.post({
    path: "/engine/asset/thumbnail/upload",
    params,
  });
};
